<mat-dialog-content>

    <div class="camera-wrapper">

        <webcam
            [width]="cameraWidth"
            [height]="cameraHeight"
            [imageType]="imageType"
            [trigger]="takeSnapshot"
            [allowCameraSwitch]="true"
            [switchCamera]="switchCamera"
            (initError)="onCameraError($event)"
            (imageCapture)="onImageCapture($event)"
            >
        </webcam>

        <div class="controls" *ngIf="showControls">

            <button mat-fab color="warn" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>

            <button mat-fab color="default" (click)="doImageCapture()">
                <mat-icon>play_arrow</mat-icon>
            </button>

            <button mat-fab color="primary" (click)="doSwitchCamera()">
                <mat-icon>cameraswitch</mat-icon>
            </button>

        </div>
    </div>
    
</mat-dialog-content>
<!--<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent">Fechar</button>
    <button mat-raised-button color="primary">Concluir</button>
</mat-dialog-actions>-->